import React, { useEffect, useState } from "react";
import { FaSquare, FaCheckSquare, FaMinusSquare } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import TreeView, { flattenTree } from "react-accessible-treeview";
import cx from "classnames";
import { Card, CardHeader, CardBody } from "../card/card";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import { useAuth } from "../../contexts/AuthContext";
import { location, machineProfile } from "../../api";
import { parserAPI } from "../../utils/parser";
import { toast } from "react-toastify";
import {
  formatDateOnly,
  generateLocationToArray,
  Loader,
} from "../../utils/helper";
import ModalNavigation from "../../pages/machine/modal/ModalNavigation";
import ImageViewer from "../ImageViewer";
import { useNavigate } from "react-router-dom";

function LocationTree({ onChangeTree }) {
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingMachine, setLoadingMachine] = useState(true);
  const [expandedIds, setExpandedIds] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const { getLocationName } = useAuth();
  const [locations, setLocations] = useState(null);
  const navigate = useNavigate();
  const [datas, setDatas] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [query, setQuery] = useState({ company: true });

  async function getMachine(id) {
    try {
      setLoadingMachine(true);
      const res = await machineProfile.getOne(id);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          setSelectedMachine(data);
        }
      }
      setLoadingMachine(false);
    } catch (e) {
      setLoadingMachine(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    console.log({ selectedIds });
  }, [selectedIds]);

  async function getLocation() {
    try {
      setLoading(true);
      const res = await location.list("","","","","",3);
      const data = await parserAPI(res);
      let exp = [];
      function transformToTreeStructure(data) {
        const resultAll = data.map((item) => {
          const newItem = {
            name: item.location_name || item.asset_name,
            id: item.id,
            metadata: {
              type: item.location_name ? "dir" : 'machine',
            },
            children: [],
          };
          if(!item.parent_location_id){
              exp.push(item.id);
          }

          if (item.sublocations && item.sublocations.length > 0) {
            // If there are subdirectories, recursively transform them

            newItem.children = transformToTreeStructure(item.sublocations);
          }

          if (item.assets && item.assets.length > 0) {
            // If there are machines, add them as children with type 'machine'
            const machineChildren = item.assets.map((machine) => ({
              name: machine.asset_name,
              id: machine.id,
              metadata: {
                type: "machine",
              },
            }));
            newItem.children = [...newItem.children, ...machineChildren];
            newItem.children = transformToTreeStructure(item.assets);

          }
          if (item.asset_components && item.asset_components.length > 0) {
            // If there are machines, add them as children with type 'machine'
            const machineChildren = item.asset_components.map((machine) => ({
              name: machine.component,
              id: machine.id,
              metadata: {
                type: "machine",
              },
            }));
            newItem.children = [...newItem.children, ...machineChildren];
            console.log("childer")
            console.log(newItem.children)
          }

          return newItem;
        });
        return resultAll;
      }
      let result = transformToTreeStructure(data);

      setExpandedIds(exp);
      const finalResult = {
        name: "",
        children: result,
      };
      // change all the sublocations into children
      const folder = flattenTree(finalResult);
      setLocations(folder);
      // recursive add children

      setLoading(false);
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  }

  const handleClickMachine = (element) => {
    console.log({ element });
    setSelectedMachine(null);
    getMachine(element.id);
    // get machine detail from data
    // const machine = datas.find((d) => d.id === element.id);
    // setSelectedMachine(machine);
    setOpenModal(true);
  };
  const handleSelectId = (selected) => {
    const mySet = selected?.treeState?.selectedIds;
    const array = Array.from(mySet);
    console.log({ selected });
    console.log({ array });
    onChangeTree(array);
  };

  useEffect(() => {
    getLocation();
  }, []);

  return (
    <div>
      <Card>
        <CardHeader>Select Location</CardHeader>
        <CardBody>
          <Loader loading={loading}>
            <div
              style={{
                height: "400px",
                overflowY: "auto",
                overflow: "auto",
              }}
            >
              <div className="checkboxer">
                {locations ? (
                  <TreeView
                    data={locations}
                    aria-label="Checkbox tree"
                    propagateSelect
                    expandedIds={expandedIds}
                    onSelect={handleSelectId}
                    multiSelect
                    //propagateSelectUpwards
                    togglableSelect
                    nodeRenderer={({
                      element,
                      isBranch,
                      isExpanded,
                      isSelected,
                      isHalfSelected,
                      getNodeProps,
                      level,
                      handleSelect,
                      handleExpand,
                    }) => {
                      return (
                        <div
                          {...getNodeProps({ onClick: handleExpand })}
                          style={{ marginLeft: 40 * (level - 1) }}
                        >
                          {isBranch && <ArrowIcon isOpen={isExpanded} />}
                          <CheckBoxIcon
                            className="checkbox-icon"
                            onClick={(e) => {
                              handleSelect(e);
                              e.stopPropagation();
                            }}
                            variant={
                              isHalfSelected
                                ? "some"
                                : isSelected
                                ? "all"
                                : "none"
                            }
                          />{" "}
                          {element.metadata?.type === "dir" ? <></> : <></>}
                          {element.metadata?.type === "machine" ? (
                            <i
                              className="fa fa-gears"
                              style={{
                                color:
                                  element.metadata?.type === "machine"
                                    ? "#9bf7ff"
                                    : "#f5faa3",
                              }}
                            ></i>
                          ) : (
                            <i
                              className={"fa fa-warehouse"}
                              style={{
                                color:
                                  element.metadata?.type === "machine"
                                    ? "#9bf7ff"
                                    : "#f5faa3",
                              }}
                            ></i>
                          )}{" "}
                          <span
                            onClick={(e) => {
                              handleSelect(e);
                            }}
                            className="name"
                            style={{
                              color:
                                element.metadata?.type === "machine"
                                  ? "#9bf7ff"
                                  : "#f5faa3",
                            }}
                          >
                            {element.name}
                          </span>
                        </div>
                      );
                    }}
                  />
                ) : null}
              </div>
            </div>
          </Loader>
        </CardBody>
      </Card>
    </div>
  );
}

const ArrowIcon = ({ isOpen, className }) => {
  const baseClass = "arrow";
  const classes = cx(
    baseClass,
    { [`${baseClass}--closed`]: !isOpen },
    { [`${baseClass}--open`]: isOpen },
    className
  );
  return <IoMdArrowDropright className={classes} />;
};

const CheckBoxIcon = ({ variant, ...rest }) => {
  switch (variant) {
    case "all":
      return <FaCheckSquare {...rest} />;
    case "none":
      return <FaSquare {...rest} />;
    case "some":
      return <FaMinusSquare {...rest} />;
    default:
      return null;
  }
};

export default LocationTree;
